import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionByDate } from 'app/shared/models/class/session/session';
import { RatingService } from 'app/shared/services/rating/rating.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

interface DialogData {
  session: SessionByDate;
}


@Component({
  selector: 'app-open-dialog-ratings',
  templateUrl: './open-dialog-ratings.component.html',
  styleUrls: ['./open-dialog-ratings.component.scss']
})
export class OpenDialogRatingsComponent extends SubscriptionBaseComponent implements OnInit {
  ratings: any[] = [];
  isLoading = false;

  constructor(
    private ratingsSrv: RatingService,
    public dialogRef: MatDialogRef<OpenDialogRatingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    super()
  }

  ngOnInit(): void {
    this.initSub();
  }

  initSub() {
    this.isLoading = true;
    this.subscription
    .add(
      this.ratingsSrv.getRatings(this.data.session.sessionKey).subscribe(ratingsFromSrv => {
        this.ratings = ratingsFromSrv;
        this.isLoading = false;
      })
    );
  }

}
